var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9938 12L23.3736 3.62021C23.7713 3.22321 23.995 2.68448 23.9955 2.12254C23.996 1.5606 23.7732 1.02148 23.3762 0.623777C22.9792 0.226074 22.4405 0.00236781 21.8786 0.00187155C21.3166 0.00137528 20.7775 0.224129 20.3798 0.621131L12 9.00092L3.62021 0.621131C3.22251 0.223428 2.68311 0 2.12067 0C1.55823 0 1.01883 0.223428 0.621131 0.621131C0.223428 1.01883 0 1.55823 0 2.12067C0 2.68311 0.223428 3.22251 0.621131 3.62021L9.00092 12L0.621131 20.3798C0.223428 20.7775 0 21.3169 0 21.8793C0 22.4418 0.223428 22.9812 0.621131 23.3789C1.01883 23.7766 1.55823 24 2.12067 24C2.68311 24 3.22251 23.7766 3.62021 23.3789L12 14.9991L20.3798 23.3789C20.7775 23.7766 21.3169 24 21.8793 24C22.4418 24 22.9812 23.7766 23.3789 23.3789C23.7766 22.9812 24 22.4418 24 21.8793C24 21.3169 23.7766 20.7775 23.3789 20.3798L14.9938 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.28eaa1040728f825c2ccac61b0a3e5f3.svg";
export { ForwardRef as ReactComponent };